import Flux from 'lib/flux';
import ViewportConstants from 'constants/viewport';
import $ from 'jquery';

export default Flux.createActionCreator({
  watchForResize() {
    $(window).resize((_e) => {
      this.dispatchAction(ViewportConstants.RESIZED);
    });
  },
});
